class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    // Presentation-only listeners: the original facets engine owns this request.
    document.dispatchEvent(new CustomEvent('coral:facets-start', { detail: { searchParams } }));

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`Collection filters returned HTTP ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        document.dispatchEvent(new CustomEvent('coral:facets-complete', { detail: { url } }));
      })
      .catch((error) => {
        // Release the existing loading UI and allow the sticky controls to retry.
        document.querySelector('#ProductGridContainer .collection')?.classList.remove('loading');
        ['ProductCount', 'ProductCountDesktop'].forEach((id) => document.getElementById(id)?.classList.remove('loading'));
        FacetFiltersForm.toggleActiveFacets(false);
        document.dispatchEvent(new CustomEvent('coral:facets-error', { detail: { url, error } }));
        console.error('[Coral Slub] Collection update failed:', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    const url = FacetFiltersForm.filterData.find(filterDataUrl).url;
    document.dispatchEvent(new CustomEvent('coral:facets-complete', { detail: { url } }));
  }
  static renderReview() {
    if (window.SPR && theme.review ) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      };
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    // Count markup is optional: some collection layouts omit #ProductCount.
    // Prefer the original translated count before using the v4 summary text.
    const source = parsedHTML.getElementById('ProductCount')
      || parsedHTML.getElementById('ProductCountDesktop')
      || parsedHTML.querySelector('.mobile-facets__count');
    const summary = parsedHTML.querySelector('[data-cs-collection-summary] .cs-collection-summary__count');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    [container, containerDesktop].forEach((element) => {
      if (!element) return;
      if (source) {
        element.innerHTML = source.innerHTML;
      } else if (summary) {
        // Copy text only; do not duplicate the summary's data attributes.
        element.textContent = summary.textContent.trim();
      }
      element.classList.remove('loading');
    });

    // Re-initialize pagination against the newly rendered collection grid.
    // Use one global Ajaxinate instance so old scroll listeners do not survive AJAX filtering/sorting.
    if (typeof window.initCollectionInfiniteScroll === 'function') {
      window.initCollectionInfiniteScroll();
    }
    theme.wishlist.load();
    theme.compare.load();
    theme.countdown.load();
    theme.swatchCard2.load();
    FacetFiltersForm.renderReview();
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // Keep the sticky presentation in sync with the original AJAX / history response.
    document.dispatchEvent(new CustomEvent('coral:facets-rendered', { detail: { document: parsedHTML } }));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formParams = new URLSearchParams(new FormData(form));
    const cleanParams = new URLSearchParams();

    // The sticky component is moved into <body>; match it to this form's section.
    const section = form.closest('.shopify-section');
    const tools = Array.from(document.querySelectorAll(
      'coral-mobile-collection-tools[data-default-sort]'
    )).find((element) =>
      section && section.id === `shopify-section-${element.dataset.sectionId}`
    );
    const defaultSort = form.dataset.defaultSort || tools?.dataset.defaultSort;

    for (const [name, value] of formParams) {
      // Internal slider value, not a Shopify filter. Keep the real price fields.
      if (name === 'ranger price') continue;

      // Blank means no constraint. Preserve zero and repeated selected values.
      if (name.startsWith('filter.') && value.trim() === '') continue;

      // Default sorting needs no URL parameter. Never guess an unknown default.
      if (name === 'sort_by' && (
        value === '' || (defaultSort && value === defaultSort)
      )) continue;

      cleanParams.append(name, value);
    }

    // Use one clean query for the original AJAX request, cache and history.
    return cleanParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.filter(Boolean).join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/* Shared native price component. Both entry points use the very same element.
 * Keep the original PriceRange / ionRangeSlider API, but scope selectors to
 * this instance. The old global selectors updated desktop and mobile together,
 * and registered another window resize handler on every drag. No global price
 * or viewport listeners are needed to keep the original form submission path.
 */
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.onBoundRangeChange = this.onRangeChange.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    // Defer once so the children also exist when inserted by the Theme Editor.
    queueMicrotask(() => {
      if (!this.isConnected || this.initialized) return;
      this.minInput = this.querySelector('.field__input_min');
      this.maxInput = this.querySelector('.field__input_max');
      this.sliderInput = this.querySelector('.sliderFilter');
      if (!this.minInput || !this.maxInput) return;
      this.initialized = true;
      this.rangeMin = Number(this.sliderInput?.dataset.min || 0);
      this.rangeMax = Number(this.sliderInput?.dataset.max || this.maxInput.max || 0);
      [this.minInput, this.maxInput].forEach((input) => {
        input.step = 'any';
        input.addEventListener('change', this.onBoundRangeChange);
      });
      this.setMinAndMaxValues();
      this.noUifilter();
    });
  }

  disconnectedCallback() {
    // Moving the SAME element into/out of the sticky dialog must not destroy it.
    queueMicrotask(() => {
      if (this.isConnected || !this.initialized) return;
      [this.minInput, this.maxInput].forEach((input) => {
        input.removeEventListener('change', this.onBoundRangeChange);
      });
      this.slider?.destroy();
      this.slider = null;
      this.initialized = false;
    });
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.noUifilter();
    // A blur/change-only edit must also work. Use the existing form input event;
    // its debounce coalesces this with a preceding keyboard input event.
    this.notifyForm();
  }

  setMinAndMaxValues() {
    const minInput = this.minInput || this.querySelector('.field__input_min');
    const maxInput = this.maxInput || this.querySelector('.field__input_max');
    if (!minInput || !maxInput) return;
    const lower = this.rangeMin ?? 0;
    const upper = this.rangeMax ?? Number(maxInput.max || 0);
    minInput.min = String(lower);
    minInput.max = maxInput.value !== '' ? maxInput.value : String(upper);
    maxInput.min = minInput.value !== '' ? minInput.value : String(lower);
    maxInput.max = String(upper);
  }

  adjustToValidValues(input) {
    // Blank means no price constraint; keep it blank so Clear All stays native.
    if (input.value === '') return;
    const value = Number(input.value);
    if (!Number.isFinite(value)) { input.value = ''; return; }
    input.value = String(Math.min(Number(input.max), Math.max(Number(input.min), value)));
  }

  noUifilter() {
    if (!this.minInput || !this.maxInput) return;
    const from = this.minInput.value === '' ? this.rangeMin : Number(this.minInput.value);
    const to = this.maxInput.value === '' ? this.rangeMax : Number(this.maxInput.value);
    if (this.slider) {
      this.slider.update({ from, to });
      return;
    }
    // Numeric inputs still work if an existing store dependency fails to load.
    const jq = window.jQuery;
    if (!this.sliderInput || !jq?.fn?.ionRangeSlider || this.rangeMax <= this.rangeMin) return;
    const updateInputs = (data) => {
      this.minInput.value = String(data.from);
      this.maxInput.value = String(data.to);
      this.setMinAndMaxValues();
      this.notifyForm();
    };
    jq(this.sliderInput).ionRangeSlider({
      skin: 'round', type: 'double', min: this.rangeMin, max: this.rangeMax,
      from, to, onChange: updateInputs, onFinish: updateInputs
    });
    this.slider = jq(this.sliderInput).data('ionRangeSlider');
  }

  notifyForm() {
    if (this.hasAttribute('data-cs-price-draft')) {
      // Only the sticky dialog stages edits. The original drawer stays immediate.
      this.dispatchEvent(new CustomEvent('coral:price-draft-change', { bubbles: true }));
      return;
    }
    const form = this.minInput?.form || this.closest('form');
    form?.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



/* Separate mobile Filter / Sort drawers, presentation only.
 * Reuses the original menu-drawer shell and #SortBy-mobile. No new form, URLs,
 * fetching, filter serialization or product-rendering engine is introduced.
 * Sort changes remain immediate via the original debounce; Apply closes the UI,
 * just like the original Filter drawer. Filter controls are never removed.
 */
if (!customElements.get('coral-facet-sort')) {
  customElements.define('coral-facet-sort', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      this.media = window.matchMedia('(max-width: 749px)');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-coral-sort-trigger]')) this.openSort();
      }, { signal });
      ['coral:facets-rendered', 'coral:facets-complete', 'coral:facets-error'].forEach((name) => {
        document.addEventListener(name, () => this.scheduleSync(), { signal });
      });
      this.media.addEventListener('change', () => {
        if (!this.media.matches) this.closeSort(false);
      }, { signal });
      window.addEventListener('pageshow', () => this.closeSort(false), { signal });
      customElements.whenDefined('menu-drawer').then(() => this.scheduleSync());
      this.scheduleSync();
    }

    disconnectedCallback() {
      if (this.panel) {
        this.drawer?.closeMenuDrawer(new Event('coral:sort-close'));
        this.details?.removeAttribute('open');
        this.finishSort(false);
      }
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
      this.container?.removeAttribute('data-coral-sort-ready');
    }

    scheduleSync() {
      if (this.syncScheduled) return;
      this.syncScheduled = true;
      queueMicrotask(() => {
        this.syncScheduled = false;
        if (this.isConnected) this.syncFromNative();
      });
    }

    nativeContext() {
      const container = this.closest('[data-coral-facets]');
      const form = container?.querySelector('#FacetFiltersFormMobile');
      const select = form?.querySelector('#SortBy-mobile');
      const controller = form?.closest('facet-filters-form');
      const drawer = form?.closest('menu-drawer');
      const details = drawer?.querySelector(':scope > details');
      if (!select || !details || typeof controller?.onSubmitHandler !== 'function'
        || typeof drawer?.closeMenuDrawer !== 'function') return null;
      return { container, form, select, drawer, details };
    }

    syncFromNative() {
      const context = this.nativeContext();
      this.trigger = this.querySelector('[data-coral-sort-trigger]');
      if (!context || !this.trigger || !this.querySelector('[data-coral-sort-template]')) {
        this.hidden = true;
        this.container?.removeAttribute('data-coral-sort-ready');
        this.closeSort(false);
        return;
      }
      this.container = context.container;
      this.hidden = false;
      this.trigger.disabled = context.select.disabled;
      this.container.setAttribute('data-coral-sort-ready', '');
      if (!this.panel) return;

      const list = this.panel.querySelector('[data-coral-sort-options]');
      const options = Array.from(context.select.options);
      const signature = JSON.stringify(options.map((option) => [option.value, option.text, option.disabled]));
      if (this.optionsSignature !== signature) {
        const focusedValue = this.panel.contains(document.activeElement) && document.activeElement.value;
        const fragment = document.createDocumentFragment();
        options.forEach((option) => {
          const label = document.createElement('label');
          label.className = 'coral-facets__sort-option';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = `coral-sort-${this.container.dataset.coralFacets}`;
          input.value = option.value;
          input.setAttribute('data-coral-sort-option', '');
          const text = document.createElement('span');
          text.textContent = option.text;
          label.append(input, text);
          fragment.appendChild(label);
        });
        list.replaceChildren(fragment);
        this.optionsSignature = signature;
        if (focusedValue) Array.from(list.querySelectorAll('input')).find((input) => input.value === focusedValue)?.focus();
      }
      list.querySelectorAll('input').forEach((input, index) => {
        input.checked = input.value === context.select.value;
        input.disabled = context.select.disabled || options[index].disabled;
      });
      const count = context.form.querySelector('.mobile-facets__count');
      this.panel.querySelector('[data-coral-sort-count]').textContent = count?.textContent.trim() || '';
    }

    openSort() {
      if (!this.media.matches || this.panel) return;
      this.syncFromNative();
      const context = this.nativeContext();
      if (!context || context.select.disabled || this.hidden) return;
      this.drawer = context.drawer;
      this.details = context.details;
      this.returnFocus = true;
      this.closing = false;
      this.optionsSignature = null;
      this.panel = this.querySelector('[data-coral-sort-template]').content.firstElementChild.cloneNode(true);
      this.panelEvents = new AbortController();
      const { signal } = this.panelEvents;
      // Capture before menu-drawer.bindEvents() can attach its generic button
      // handlers after an AJAX render. Never run two close handlers for Apply.
      this.panel.addEventListener('click', (event) => {
        if (!event.target.closest('[data-coral-sort-close]')) return;
        event.preventDefault();
        event.stopPropagation();
        this.closeSort();
      }, { signal, capture: true });
      this.panel.addEventListener('change', (event) => this.onSortChange(event), { signal });
      this.panel.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.closeSort();
      }, { signal, capture: true });
      this.details.appendChild(this.panel);
      this.container.setAttribute('data-coral-facet-mode', 'sort');
      // In a sorting-only section, expose the shell only while the drawer is open.
      this.drawer.setAttribute('data-coral-sort-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.trigger.setAttribute('aria-controls', this.panel.querySelector('[role="dialog"]').id);
      this.syncFromNative();
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => {
        if (!this.details.open && this.panel) this.finishSort(this.returnFocus);
      });
      this.observer.observe(this.details, { attributes: true, attributeFilter: ['open'] });
      if (!this.details.open) this.details.querySelector(':scope > summary').click();
      requestAnimationFrame(() => {
        if (!this.panel || !this.details.open || this.closing) return;
        const first = this.panel.querySelector('input:checked:not(:disabled)')
          || this.panel.querySelector('input:not(:disabled), button');
        // Trap only this view, not the original inputs hidden behind it.
        if (typeof trapFocus === 'function') trapFocus(this.panel, first);
        else first?.focus();
      });
    }

    closeSort(restoreFocus = true) {
      if (!this.panel || this.closing) return;
      this.returnFocus = restoreFocus;
      this.closing = true;
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.details.open) {
        this.drawer.closeMenuDrawer(new Event('coral:sort-close'));
      } else {
        this.finishSort(restoreFocus);
      }
    }

    finishSort(restoreFocus) {
      const active = document.activeElement;
      const mayRestore = active === document.body || this.panel?.contains(active)
        || active === this.details?.querySelector(':scope > summary');
      this.observer?.disconnect();
      this.panelEvents?.abort();
      this.panelEvents = null;
      this.panel?.remove();
      this.panel = null;
      this.optionsSignature = null;
      this.closing = false;
      this.container?.removeAttribute('data-coral-facet-mode');
      this.drawer?.removeAttribute('data-coral-sort-open');
      this.details?.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger?.removeAttribute('aria-controls');
      if (restoreFocus && mayRestore && this.media.matches && this.trigger?.isConnected) {
        this.trigger.focus({ preventScroll: true });
      }
    }

    onSortChange(event) {
      const input = event.target.closest('[data-coral-sort-option]');
      if (!input || !input.checked) return;
      const context = this.nativeContext();
      if (!context || !Array.from(context.select.options).some((option) => option.value === input.value && !option.disabled)) {
        this.syncFromNative();
        return;
      }
      if (context.select.value === input.value) return;
      context.select.value = input.value;
      // The only submission: use the ORIGINAL input event, debounce, form and
      // AJAX pipeline. Radio inputs are outside any form, so they add no params.
      context.select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
}
